import { render } from "./ActivateComponent.vue?vue&type=template&id=556dc7f4&scoped=true"
import script from "./ActivateComponent.vue?vue&type=script&lang=js"
export * from "./ActivateComponent.vue?vue&type=script&lang=js"

import "./ActivateComponent.vue?vue&type=style&index=0&id=556dc7f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556dc7f4"]])

export default __exports__